














































import { Vue, Component, Watch } from 'vue-property-decorator';
import { VueConstructor } from 'vue/types/vue';
import {namespace} from "vuex-class";

import LeftDrawer from '@/views/Drawers/LeftDrawerLayout.vue';
import EmptyVueComponent from '@/views/components/EmptyVueComponent.vue';
import HomeHeader from '@/views/components/Home/HomeHeader.vue';
import HomeContent from '@/views/components/Home/HomeContent.vue';
import DropupStart from '@/views/Dropups/views/DropupStart.vue';
import SelectDestination from '@/views/Dropups/views/SelectDestination.vue';
import DropupLayout from '@/views/Dropups/DropupLayout.vue';
import RegisterOnboarding from '@/views/components/onboarding/Onboarding.vue';

import {IDropupParams, IDropupStates, DROPUP_STATE_VALUES} from "@/models/BasicModels";
import {defaultDropupParam, selectHubDropupParams, defaultHubDropupParams} from "@/constants/dropUpParams";
import {ANALYTIC_CLICKS} from "@/services/Analytics";
import {IOnOffHandlers} from "@/models/IOnOffHandlers";
import {SHOW_TEMPORAL_SERVICE_INTERRUPTION_POP_UP} from "@/constants/environment";

const userData = namespace("userData");


@Component({
  name: 'Home',
  components: {
    LeftDrawer,
    HomeHeader,
    DropupLayout,
    DropupStart,
    HomeContent,
    SelectDestination,
    RegisterOnboarding,
  },
})
export default class Home extends Vue {
  @userData.Getter('userSmsWasValidated')
  private userSmsWasValidated!: boolean;

  @userData.Getter('getPhone')
  private userPhone!: boolean;

  private showHowItWorks: boolean = false;
  private drawerProps: object = {};
  private showLeftDrawer: boolean = false;
  private vueComponentDrawer: VueConstructor = EmptyVueComponent;

  // dropup state
  private dropupCurrentContent: DROPUP_STATE_VALUES = DROPUP_STATE_VALUES.INITIAL_SCREEN;

  private DROPUP_STATES: IDropupStates =  {
    INITIAL_SCREEN: DROPUP_STATE_VALUES.INITIAL_SCREEN,
    SELECT_DESTINATION: DROPUP_STATE_VALUES.SELECT_DESTINATION,
    SHOW_ALL_HUBS: DROPUP_STATE_VALUES.SHOW_ALL_HUBS,
    SHOW_ONE_HUB: DROPUP_STATE_VALUES.SHOW_ONE_HUB,
    SELECT_DEFAULT_HUB: DROPUP_STATE_VALUES.SELECT_DEFAULT_HUB,
  };

  private dropupValues: IDropupParams = defaultDropupParam;
  private currentAsId: number|string = -1;
  private currentHubId: number|string = -1;
  private myEvents: IOnOffHandlers = {};

  @Watch('dropupCurrentContent')
  private onDropupContentChange(val: string, oldVal: string) {
    if (oldVal === this.DROPUP_STATES.SHOW_ALL_HUBS && oldVal !== val) {
      ANALYTIC_CLICKS.hubMap(this.$gtag, false);
    } else if (val === this.DROPUP_STATES.SHOW_ALL_HUBS) {
      ANALYTIC_CLICKS.hubMap(this.$gtag, true);
    }
  }

  private created() {
    this.myEvents = this.$ons({
      "drawer:show": this.openDrawer,
      "drawer:hide": this.closeDrawer,
      "dropup:revertToInitialScreen": this.revertToInitialScreenDropup,
      "dropup:openSelectDestination": this.showSelectDestinationDropup,
      "dropup:showAllHubs": this.showAllHubsDropup,
      "how-it-works:show": this.executeHowItWorks,
    });
    if (SHOW_TEMPORAL_SERVICE_INTERRUPTION_POP_UP) {
      this.$uiBus.emit("dialog:serviceInterruption:show");
    }
  }

  private beforeDestroy() {
    this.$offs(this.myEvents);
  }

  private executeHowItWorks() {
    this.showHowItWorks = true;
    this.closeDrawer();
  }

  private closeHowItWorks() {
    this.showHowItWorks = false;
  }

  private openDrawer(modalBody: VueConstructor, props: object = {} ) {
    this.vueComponentDrawer = modalBody;
    this.drawerProps = props;
    this.showLeftDrawer = true;
  }

  private closeDrawer() {
    this.vueComponentDrawer = EmptyVueComponent;
    this.drawerProps = {};
    this.showLeftDrawer = false;
  }

  private updateDropupStateInitial() {
    this.dropupCurrentContent = this.DROPUP_STATES.INITIAL_SCREEN;
    this.dropupValues = defaultDropupParam;
  }

  private updateDropupStateToSelectDestination() {
    this.dropupCurrentContent = this.DROPUP_STATES.SELECT_DESTINATION;
    this.dropupValues = selectHubDropupParams;
  }


  private updateDropupStateToShowAllHubs() {
    this.dropupCurrentContent = this.DROPUP_STATES.SHOW_ALL_HUBS;
    this.dropupValues = defaultDropupParam;
  }

  private updateDropupStateToOneHub() {
    this.dropupCurrentContent = this.DROPUP_STATES.SHOW_ONE_HUB;
    this.dropupValues = selectHubDropupParams;
  }

  private revertToInitialScreenDropup() {
    this. dropupValues = defaultDropupParam;
    this.currentAsId = -1;

    this.updateDropupStateInitial();
  }

  private showAllHubsDropup() {
    this.updateDropupStateToShowAllHubs();
    this.currentAsId = -1;
    this.currentHubId = -1;
    this.$uiBus.emit("dropup:open"); // to open with the route
  }

  private showSelectDestinationDropup(asId: number|string) {
    this.updateDropupStateToSelectDestination();
    this.currentAsId = asId;
    this.currentHubId = -1;
    this.$uiBus.emit("dropup:open"); // to open with the route
  }

  private showOneHub(hubId: number|string) {
    this.updateDropupStateToOneHub();
    this.currentAsId = -1;
    this.currentHubId = hubId;
    this.$uiBus.emit("dropup:open"); // to open with the route
  }

}
